import React, { useState } from 'react';
import Slider from 'react-slick';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Link, useNavigate } from 'react-router-dom';
import Navbar from '../components/navbar';


// Custom Previous Arrow
const PrevArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div className={`${className} custom-arrow prev-arrow`} style={{ ...style }} onClick={onClick} />
  );
};

// Custom Next Arrow
const NextArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div className={`${className} custom-arrow next-arrow`} style={{ ...style }} onClick={onClick} />
  );
};

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!email || !password) {
      setError('Please enter both email and password.');
      return;
    }

    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/Vendorlogin`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({ email, password }),
      });

      if (!res.ok) throw new Error('Network response was not ok');

      const data = await res.json();

      if (data.status === 'ok') {
        const { vendortoken, vendorId } = data.data;
        alert('Login successful');
        window.localStorage.setItem('vendortoken', vendortoken);
        window.localStorage.setItem('vendorId', vendorId);
        window.localStorage.setItem('loggedIn', true);
        window.location.href = './';
      } else {
        setError('Login failed. Please check your credentials.');
      }
    } catch (err) {
      console.error('Login error:', err);
      setError('An error occurred. Please try again later.');
    }
  };

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
  };

  return (
   <div>
     <ToastContainer position="top-center" autoClose={3000} />
      <Navbar />
       <div className="signup-page">
        <div className="login-left">
        <h2>Grow Faster with Trusted Vendor Solutions</h2>
<p>Join a powerful network that helps you scale, connect, and succeed in today’s competitive market.</p>
<ul>
  <li><strong>Instant Brand Trust:</strong> Get recognized with our verified vendor badge.</li>
  <li><strong>Expand Your Network:</strong> Reach thousands of potential buyers across the globe.</li>
  <li><strong>All-in-One Dashboard:</strong> Manage products, orders, and insights from one place.</li>
</ul>
        </div>
        

          {/* Right Side Form */}
          <div className="signup-right">
            <h3 className="mb-4 text-center">Login</h3>
            {error && <div className="alert alert-danger">{error}</div>}
            <form onSubmit={handleSubmit} className="signup-form">
              <div className="mb-3 input-group">
               
                <input
                  type="email"
                  className="form-control signupinput"
                  placeholder="Enter Email Id"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
              <div className="mb-3 input-group">
               
                <input
                  type="password"
                  className="form-control signupinput"
                  placeholder="Enter password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </div>
              <div className="text-end">
                <Link to="/ForgetPassword">Forgot Password?</Link>
              </div>
              <div className="d-grid mt-3">
                <button type="submit" className="btn btn-dark btn-submit w-100">
                  Login
                </button>
              </div>
            </form>
            <p className="text-center mt-3">
              Don't have an account? <Link to="/vendor/Signup">Create Account</Link>
            </p>
          </div>
        </div>
      </div>

  );
};

export default Login;
